import { LoginForm } from "../../../presentation/schemas/login_form";
import { ILoginUseCase } from "../../../presentation/useCases/read/login_use_case";
import { AuthInformation } from "../../models/auth_information";
import { IAuthRepository } from "../../repositories/auth_repository";

/**
 * LoginUseCase
 */

export class LoginUseCase implements ILoginUseCase {
  constructor(
    private readonly repository: IAuthRepository,
  ) { }

  async login(form: LoginForm): Promise<AuthInformation> {
    return await this.repository.login(form.login, form.password);
  }
}